function track(actionName) {
  this.$gtag.event(actionName);
}

export { track };
